import React from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import { tipRate } from 'shared/models/api';
import OrderTracking from './';

class OrderTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipSelected: null,
      tipAmount: '0.00',
      rateSelected: 0,
      tipped: !!props.order.order_tip,
      rated: !!props.order.order_rating
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.order.order_tip &&
      this.props.order.order_tip !== prevProps.order.order_tip
    ) {
      this.setState({ tipped: true });
    }
    if (
      this.props.order.order_rating &&
      this.props.order.order_rating !== prevProps.order.order_rating
    ) {
      this.setState({ rated: true });
    }
  }

  render() {
    return (
      <OrderTracking>
        {!this.state.tipped ? (
          <div className="order-tip order-tracking-container">
            <span className="order-tip-amount">${this.state.tipAmount}</span>
            <span className="order-tip-desc">
              Your order total was ${this.props.order.total.toFixed(2)} + ${this.state.tipAmount}
            </span>
            {this.state.tipSelected != -1 ? (
              <div className="order-tip-option">
                <span
                  className={
                    'order-tip-option-item' +
                    (this.state.tipSelected == 0 ? ' active' : '')
                  }
                  onClick={this.selectTip.bind(this, 0)}
                >
                  No Tip
                </span>
                <span
                  className={
                    'order-tip-option-item' +
                    (this.state.tipSelected == 10 ? ' active' : '')
                  }
                  onClick={this.selectTip.bind(this, 10)}
                >
                  10%
                </span>
                <span
                  className={
                    'order-tip-option-item' +
                    (this.state.tipSelected == 15 ? ' active' : '')
                  }
                  onClick={this.selectTip.bind(this, 15)}
                >
                  15%
                </span>
                <span
                  className={
                    'order-tip-option-item' +
                    (this.state.tipSelected == 20 ? ' active' : '')
                  }
                  onClick={this.selectTip.bind(this, 20)}
                >
                  20%
                </span>
                <span
                  className={
                    'order-tip-option-item' +
                    (this.state.tipSelected == -1 ? ' active' : '')
                  }
                  onClick={this.selectTip.bind(this, -1)}
                >
                  Other
                </span>
              </div>
            ) : (
              <div className="order-tip-option-other">
                <span
                  className="order-tip-option-other-cancel"
                  onClick={this.selectTip.bind(this, null)}
                >
                  Cancel
                </span>
                <input
                  className="order-tip-option-other-input"
                  type="text"
                  placeholder="$0.00"
                  onChange={this.updateTipAmount.bind(this)}
                />
                <span className="order-tip-option-item active">Other</span>
              </div>
            )}
            <span
              className="order-tip-submit-button button"
              onClick={this.tip.bind(this)}
            >
              Continue
            </span>
            <span className="order-tip-disclaim">
              100% of the tip goes to the courier
            </span>
          </div>
        ) : !this.state.rated ? (
          <div className="order-rate order-tracking-container">
            <div className="order-rate-option">
              <h2 className="order-rate-option-header">How did we do?</h2>
              <span
                className={
                  'fa fa-star order-rate-option-item' +
                  (this.state.rateSelected > 0 ? ' active' : '')
                }
                onClick={this.selectRate.bind(this, 1)}
              />
              <span
                className={
                  'fa fa-star order-rate-option-item' +
                  (this.state.rateSelected > 1 ? ' active' : '')
                }
                onClick={this.selectRate.bind(this, 2)}
              />
              <span
                className={
                  'fa fa-star order-rate-option-item' +
                  (this.state.rateSelected > 2 ? ' active' : '')
                }
                onClick={this.selectRate.bind(this, 3)}
              />
              <span
                className={
                  'fa fa-star order-rate-option-item' +
                  (this.state.rateSelected > 3 ? ' active' : '')
                }
                onClick={this.selectRate.bind(this, 4)}
              />
              <span
                className={
                  'fa fa-star order-rate-option-item' +
                  (this.state.rateSelected > 4 ? ' active' : '')
                }
                onClick={this.selectRate.bind(this, 5)}
              />
            </div>
            <span
              className="order-rate-submit-button button"
              onClick={this.rate.bind(this)}
            >
              Continue
            </span>
          </div>
        ) : (
          <div className="order-finish order-tracking-container">
            <h1 className="order-finish-title">
              Thanks for ordering with Saucey.
            </h1>
            <a href="/" className="order-rate-submit-button button">
              Return To The Store
            </a>
          </div>
        )}
      </OrderTracking>
    );
  }

  selectTip(percent) {
    let tipAmount = this.state.tipAmount;
    if (percent != -1) {
      tipAmount = (this.props.order.pre_discount_total *
        percent *
        10 /
        1000
      ).toFixed(2);
    }
    this.setState({
      ...this.state,
      tipSelected: percent,
      tipAmount: tipAmount
    });
  }

  updateTipAmount(event) {
    let value = parseFloat(event.target.value);
    if (isNaN(value)) value = 0;
    this.setState({ ...this.state, tipAmount: value.toFixed(2) });
  }

  tip() {
    //tipRate(this.props.order._id, this.state.tipAmount, this.state.rateSelected).catch(error => console.log(error));
    this.setState({ ...this.state, tipped: true });
  }

  selectRate(rating) {
    this.setState({ ...this.state, rateSelected: rating });
  }

  rate() {
    tipRate(
      this.props.order._id,
      this.state.tipAmount,
      this.state.rateSelected
    ).catch(error => console.log(error)); // eslint-disable-line no-console
    this.setState({ ...this.state, rated: true });
  }
}

function mapStateToProps(state) {
  return { ...state.orderTracking };
}

export default connect(mapStateToProps, { ...actions })(OrderTip);



// WEBPACK FOOTER //
// ./shared/components/orderTracking/tip.js